import React from "react";

export function ShareIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" stroke="currentColor" fill="currentColor" width="1em" height="1em" viewBox="0 0 16.0 16.0" version="1.1" className="icon--share">
      <path d="M 9.5374969,4.3911929 C 8.3783013,4.3188252 -2.3879861,5.6397971 2.5300646,14.74838 c 0,0 -0.6659861,-7.0105386 6.992853,-6.3197191 V 11.678072 L 14.748347,6.4585461 9.5357258,1.2518143 Z" />
    </svg>
  );
}
